import { CHAVE_USUARIO, CHVAE_TOKEN, CACHE_EMPRESA } from '@/global';

export default {
    namespaced: true,
    state: {
        usuario: null,
        permissoes: [],
        dadosRequisicao: null,   
        isAutenticado: false,  
        cacheEmpresa: null,      
    },
    getters: {
        getCacheEmpresa(state) {
            return state.cacheEmpresa;
        },
        getUsuario(state) {
            return state.usuario;
        },
        getPermissoes(state) {
            return state.permissoes;
        },
        getDadosRequisicao(state) {
            return state.dadosRequisicao;
        },
        getIsAutenticado(state) {
            return state.isAutenticado;
        },      
    },
    mutations: {
        setCacheEmpresa(state, cacheEmpresa) {
            state.cacheEmpresa = cacheEmpresa;
        },
        setUsuario(state, usuario) {
            state.usuario = usuario;
        },
        setPermissoes(state, permissoes) {            
            state.permissoes = permissoes;            
        },
        setDadosRequisicao(state, dados) {
            state.dadosRequisicao = dados;
        },
        setIsAutenticado(state, autenticado) {
            state.isAutenticado = autenticado;
        },  
        setPeriodoFechamento(state, periodoFechamento) {
            state.dadosRequisicao.empresa.diaInicioFechamento = periodoFechamento.diaInicioFechamento;
            state.dadosRequisicao.empresa.diaFinalFechamento = periodoFechamento.diaFinalFechamento;
        }             
    },
    actions: {
        criarSessao(context, dados) {             
            let justificativas = [];
            dados.justificativas.forEach(just => {
                justificativas.push({...just});
            });
            let cnpjs = [];
            dados.cnpjs.forEach(cnpj => {
                cnpjs.push({...cnpj});
            });
            let respLogin = {
                requisicao: {
                    usuario: {...dados.usuario},
                    empresa: {...dados.empresa},
                    cnpj: {...dados.cnpj},
                    justificativas: justificativas,
                    permissoes: [...dados.permissoes],
                },
                cacheEmpresa: {
                    idCnpjSelecionado: null,
                    cnpjSelecionado: null,
                    cnpjs: cnpjs,
                    centrosCustos: []
                },
                versao: dados.versao,
                token: {...dados.token}
            } 
            let dadosCacheEmpresa = JSON.parse(sessionStorage.getItem(CACHE_EMPRESA)); 
            if(dadosCacheEmpresa) {
                respLogin.cacheEmpresa = dadosCacheEmpresa;
            }
            // Dados gerais
            sessionStorage.setItem(CHAVE_USUARIO, JSON.stringify(dados));   
            // Somente o token
            sessionStorage.setItem(CHVAE_TOKEN, JSON.stringify({...respLogin.token}));                   
            context.commit('setUsuario', {...respLogin.requisicao.usuario}); 
            let permissoes = [...respLogin.requisicao.permissoes];
            permissoes.push(0);
            context.commit('setCacheEmpresa', {...respLogin.cacheEmpresa}); 
            context.commit('setPermissoes', permissoes);          
            context.commit('setDadosRequisicao', {...respLogin.requisicao});  
            context.commit('setIsAutenticado', true);
        },
        atualizarPeriodoFechamento(context, periodoFechamento) {
            context.commit('setPeriodoFechamento', periodoFechamento);  
        },
        atualizarCacheEmpresa(context, cacheEmpresa) {
            let dados = JSON.parse(sessionStorage.getItem(CACHE_EMPRESA));  
            dados = cacheEmpresa;
            sessionStorage.setItem(CACHE_EMPRESA, JSON.stringify(dados)); 
            context.commit('setCacheEmpresa', cacheEmpresa);  
        },
        limparSessao(context) {
            sessionStorage.clear();
            localStorage.clear();
            context.commit('setCacheEmpresa', null); 
            context.commit('setUsuario', null);             
            context.commit('setPermissoes', []);            
            context.commit('setDadosRequisicao', null);
            context.commit('setIsAutenticado', false);            
        },            
    }
}